/**
 * @fileoverview
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../../reactQueryFetcherAdapters";
import { testUserNamesCacheKey } from "./constants";
import type { TestUserNamesResult } from "./types";

export const getTestUserNames = reactQueryFetcherAdapter(
  testUserNamesCacheKey,
  (signal: AbortSignal, testUserIdsToExclude: string[]): Promise<TestUserNamesResult> => {
    return fetch(
      "/internal_user_groups/test_user_names",
      "GET",
      { test_users_ids_to_exclude: testUserIdsToExclude },
      { signal }
    );
  }
);
